<script lang="ts">
  import { getContextedUrl, numberTo2Digits } from '../../../common/util';
  import Icon from '../components/Icon.svelte';

  export let data;

  let videoEl;
  let muted = false;
  let videoTimeRemainingSeconds = 0;
  let contexedRedirectionUrl;

  $: volume = muted ? 0 : 1;
  $: if (videoEl && videoEl.volume) {
    videoEl.volume = volume;
  }
  $: timeRemaining = formatSecondsToMMSS(videoTimeRemainingSeconds);
  $: if (data && data.redirectionUrl?.length > 0) {
    contexedRedirectionUrl = getContextedUrl(data.redirectionUrl);
  }
  $: if (typeof muted === 'boolean' && videoEl) {
    videoEl.muted = muted;
  }

  function onVideoTimeUpdate(event) {
    const timeElapsed = event.target.currentTime;
    const duration = event.target.duration;
    videoTimeRemainingSeconds = Math.round(duration - timeElapsed);
  }
  function formatSecondsToMMSS(secondsValue) {
    let minutes = 0;
    let seconds = secondsValue;
    if (secondsValue > 59) {
      minutes = secondsValue / 60;
      seconds = secondsValue % 60;
    }
    return `${numberTo2Digits(minutes)}:${numberTo2Digits(seconds)}`;
  }
  function onCTAClick(_e) {
    window.ACC.loader.showLoader();
    window.location.assign(contexedRedirectionUrl);
  }
</script>

<section class="story-slide">
  <section class="story-image-area">
    {#if data.mimeType === 'VIDEO'}
      <video bind:this={videoEl} on:timeupdate={onVideoTimeUpdate} playsinline>
        <track kind="captions" />
        <source src={data.mediaUrl + '/webm_480p'} type="video/webm" />
        <source src={data.mediaUrl + '/mp4_480p'} type="video/mp4" />
        <source src={data.mediaUrl + '/webm_1080p'} type="video/webm" />
        <source src={data.mediaUrl + '/mp4_1080p'} type="video/mp4" />
      </video>
      <button class="mute-btn" class:muted on:click={() => (muted = !muted)}>
        {#if muted}
          <Icon glyph="volume-off" size={28} />
        {:else}
          <Icon glyph="volume-on" size={28} />
        {/if}
      </button>
      <section class="timer-tag">{timeRemaining}</section>
    {:else}
      <img src={data.mediaUrl} alt="Extra Story" />
    {/if}
  </section>
  <h3>{@html data.storyTitle}</h3>
  <p>{@html data.storyDescription}</p>
  {#if typeof contexedRedirectionUrl === 'string'}
    <a href={contexedRedirectionUrl} class="story-cta" on:click|preventDefault={onCTAClick}>{data.submitButtonLabel}</a>
  {/if}
</section>

<style lang="scss">
  @import '../styles/colors.new.scss';

  .story-slide {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;

    .story-image-area {
      flex-grow: 1;
      height: calc(100vh - 250px);
      height: calc(100dvh - 250px);
      position: relative;

      .mute-btn {
        position: absolute;
        right: 0;
        bottom: -38px;
        border: none;
        aspect-ratio: 1;
        background-color: transparent;
        color: white;
      }
      .timer-tag {
        position: absolute;
        left: 10px;
        bottom: 10px;
        background-color: rgba(0, 0, 0, 20%);
        color: white;
        padding: 5px 10px;
        border-radius: 8px;
        font-weight: 700;
      }
    }
    img,
    video {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 20px;
      overflow: hidden;
    }
    h3 {
      margin: 0;
      font-size: 24px;
      line-height: 28px;
      font-weight: 700;
      padding-inline: 50px;
      text-align: center;
    }
    p {
      font-size: 14px;
      line-height: 16px;
      font-weight: 400;
      margin: 0;
    }
    .story-cta {
      padding: 10px 16px;
      border-radius: 100px;
      background-color: $functional-yellow;
      font-size: 14px;
      line-height: 16px;
      font-weight: 700;
      color: $primary-black;
    }
  }
</style>
